module.exports = __webpack_public_path__ + "img/topicLeisure.763ff0f3.webp";